(function () {
  angular
    .module('trackeye')
    .factory('SunWeekParser', _SunWeekParserFactory);

  _SunWeekParserFactory.$inject = [];

  function _SunWeekParserFactory() {

    function SunWeekParser(time) {
      this.dateArray = []
      if (typeof time === "string") {
        this.dateArray = this.parseSunWeekString(time)
      } else if (time instanceof Array) {
        this.dateArray = this.parseStringArray(time)
      }
    }

    SunWeekParser.prototype.parseSunWeekString = function(time) {
      // Splits the week/sun string, into individual segments like {9,0}
      var parts = time.split(/(\{\d+,\d+\}),?/);
      // console.log(parts);
      return parts.filter(function (v) {
        return !!v.match(/\{\d+,\d+\}/);
      }).map(function (v) {
        var split = v.slice(0, -1).slice(1).split(/(\d+),(\d+)/),
          tmp = new Date()

        tmp.setUTCHours(split[1]);
        tmp.setUTCMinutes(rpad(split[2], true));

        return tmp
      }).sort(sortLowToHigh);
    }

    SunWeekParser.prototype.parseStringArray = function(time) {
      var round_to = 10
      return time.map(function(t) {
        var parts = t.match(/(\d{2})([\.\:\-])?(\d{2})/)

        if (!parts) {
          return undefined;
        }

        var hour = parseInt(parts[1], 10),
            tmp_min = parseInt(parts[3], 10),
            min = Math.round(tmp_min / round_to) * round_to;

        min = (min >= 60) ? (min - round_to) : min;

        var tmp = new Date()

        tmp.setHours(hour)
        tmp.setMinutes(min)

        return tmp
      })
      .filter(function(t) {
        return t instanceof Date
      })
      .sort(sortLowToHigh)
    }

    SunWeekParser.prototype.hasItems = function() {
      return !!this.dateArray.length
    }

    SunWeekParser.prototype.toStringArray = function() {
      return this.dateArray.map(function(d) {
        var localMoment = moment().utc()
        localMoment.hours(d.getUTCHours())
        localMoment.minutes(d.getUTCMinutes())
        localMoment.local()
        return lpad(localMoment.hours())+":"+rpad(localMoment.minutes());
      }).sort(sortLowToHigh)
    }

    SunWeekParser.prototype.toString = function() {
      if (!this.dateArray.length)
        return "";

      return this.dateArray
        .sort(sortLowToHighHour)
        .map(function (d) {
          var hourUnpad = lunpad(d.getUTCHours())
          var minutes = d.getUTCMinutes()
          return "{"+hourUnpad+","+minutes+"}";
        }).join(',')
    }

    function sortLowToHigh(ts1, ts2) {
      if (ts1 > ts2) {
        return 1;
      } else if (ts1 < ts2) {
        return -1;
      }
      return 0;
    }

    function sortLowToHighHour(ts1, ts2) {
      var utc1 = ts1.getUTCHours()
      var utc2 = ts2.getUTCHours()

      if (utc1 > utc2) {
        return 1;
      } else if (utc1 < utc2) {
        return -1;
      }
      return 0;
    }

    /**
     * Returns a 2 digit number, with a zero left-padded
     * 8 -> 08
     * @param {number} num
     * @param {boolean} [as_int]
     * @returns {string|number}
     */
    function lpad(num, as_int) {
      var tmp = ("0" + num).slice(-2);
      return as_int ? parseInt(tmp, 10) : tmp;
    }
    
    /**
     * Returns a zero left-padded number as a single digit
     *
     * @param {number} num
     * @returns {string}
     */
    function lunpad(num) {
      return ("0" + num).slice(1);
    }

    /**
     * Returns a 2 digit number, with a zero right-padded
     * 4 -> 40
     * @param {number} num
     * @param {boolean} [as_int]
     * @returns {string|number}
     */
    function rpad(num, as_int) {
      var tmp = (num + "0").slice(0, 2);
      return as_int ? parseInt(tmp, 10) : tmp;
    }

    return SunWeekParser
  }
}());